export interface OperationProgress {
  readonly closed: boolean;
  readonly executionStatus: string;
  readonly coordinationState: string;
  readonly openPendingCount: number;
  readonly checklistComplete: boolean;
  readonly authorityResult: string | undefined;
}
// A navigation suggestion only; the server remains responsible for every transition.
export function operationNextStep(progress: OperationProgress) {
  if (progress.closed)
    return { section: 'operation-report', title: 'Consultar o relatório da operação' };
  if (progress.executionStatus === 'completed' || progress.executionStatus === 'cancelled')
    return { section: 'operation-closure', title: 'Conferir e encerrar a operação' };
  if (progress.executionStatus === 'in_progress')
    return { section: 'operation-execution', title: 'Acompanhar a execução' };
  if (progress.openPendingCount > 0 || !progress.checklistComplete)
    return { section: 'operation-pending', title: 'Revisar as pendências e o checklist' };
  if (progress.coordinationState !== 'ready')
    return { section: 'coordination-decision', title: 'Conferir a conclusão da coordenação' };
  if (progress.authorityResult !== 'authorized')
    return { section: 'operational-decision', title: 'Revisar a decisão operacional' };
  return { section: 'operation-execution', title: 'Acompanhar a execução' };
}
